// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"b4bba6b9","252":"081e7da3","370":"852cfd19"}[chunkId] + ".chunk.js";
};